import { createApp } from 'vue';
import {createRouter, createWebHistory} from 'vue-router';
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/reset.css';
import DlcView from "@/DlcView.vue";
import ContactView from "@/ContactView.vue";
import VdiContactView from "@/VdiContactView.vue";

const app = createApp(App);

const routes = [
    { path: "/", component: DlcView },
    { path: "/contact", component: ContactView },
    { path: "/vdi-contact", component: VdiContactView },
    { path: "/dlc", }
]

const router = createRouter({
    history: createWebHistory("/"),
    routes
});

app.use(router).use(Antd).mount('#app');
